<component :is="currentComponent" :module="module"></component>